import './legacy_jquery'

let ready_admin;

ready_admin = function () {
  $('body').on('change', '.domain_customer_domains_role select', function () {
    var button, octet_select;
    octet_select = $(this).closest('.row').find('.domain_customer_domains_allowed_octets select');
    button = $(this).closest('.row').find('.domain_customer_domains_allowed_octets button');
    if ($(this).val() === "owner") {
      octet_select.prop('disabled', true);
      button.prop('disabled', true);
      octet_select.selectpicker('refresh');
      return octet_select.selectpicker('deselectAll');
    } else {
      octet_select.prop('disabled', false);
      button.prop('disabled', false);
      return octet_select.selectpicker('refresh');
    }
  });
  $('body').on('click', '.allowed_octets_select_all', function (e) {
    var octet_select;
    e.preventDefault();
    octet_select = $(this).closest('.row').find('.domain_customer_domains_allowed_octets select');
    return octet_select.selectpicker('selectAll');
  });
  $('body').on('click', '.allowed_octets_deselect_all', function (e) {
    var octet_select;
    e.preventDefault();
    octet_select = $(this).closest('.row').find('.domain_customer_domains_allowed_octets select');
    return octet_select.selectpicker('deselectAll');
  });
  return $('body').on('change', '.domain_slave_only_zone input', function (e) {
    if ($(this).is(":checked")) {
      return $('.slave_only_zone_container').show();
    } else {
      return $('.slave_only_zone_container').hide();
    }
  });
};

$(document).ready(ready_admin);

$(document).on('turbo:load', ready_admin);